<div class="cw-ledger-wrapper">
  <div class="cw-ledger-header">
    <h5 class="blue-text" data-pw="cw_ledger_title" data-qa="cw_ledger_title">Class Wallet Ledger</h5>
    <div class="cw-ledger-running-balance" data-pw="cw_ledger_running_balance" data-qa="cw_ledger_running_balance">
      <span class="cw-ledger-running-balance-label">Running Balance:</span>
      <span
        class="cw-ledger-running-balance-value"
        [class.cw-amount-expense]="runningBalance < 0"
        [class.cw-amount-paid]="runningBalance > 0">
        {{ runningBalance | currency: 'USD' : 'symbol' : '1.2-2' }}
      </span>
    </div>
  </div>

  @if (rows().length === 0) {
    <div class="cw-ledger-empty" data-pw="cw_ledger_empty_state" data-qa="cw_ledger_empty_state">
      <span class="neutral-text">No transactions found</span>
    </div>
  } @else {
    <cfi-mat-table
      [data]="rows()"
      [columnDefinitions]="columnDefinitions"
      [displayedColumns]="displayedColumns"
      [columnsToDisplayWithExpand]="displayedColumns"
      [paginated]="true"
      [defaultPageSize]="5"
      [currentPageSize]="5"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSizeSelector]="false"
      [striped]="true"
      [sortKey]="'expenseFileDate'"
      [sortDirection]="'desc'"
      data-pw="cw_ledger_table"
      data-qa="cw_ledger_table">

      <!-- Header Template -->
      <ng-template #headerTemplate let-column>
        {{ column.header }}
      </ng-template>

      <!-- Cell Template -->
      <ng-template #cellTemplate let-row let-column="column">
        @switch (column.name) {
          @case ('expenseFileDate') {
            <td data-pw="cw_ledger_post_date_cell" data-qa="cw_ledger_post_date_cell">
              {{ row.expenseFileDate | date: 'MM/dd/yyyy' }}
            </td>
          }
          @case ('academicYear') {
            <td data-pw="cw_ledger_academic_year_cell" data-qa="cw_ledger_academic_year_cell">
              {{ row.academicYear }}
            </td>
          }
          @case ('term') {
            <td data-pw="cw_ledger_term_cell" data-qa="cw_ledger_term_cell">
              {{ row.term }}
            </td>
          }
          @case ('program') {
            <td data-pw="cw_ledger_program_cell" data-qa="cw_ledger_program_cell">
              {{ row.program }}
            </td>
          }
          @case ('description') {
            <td data-pw="cw_ledger_description_cell" data-qa="cw_ledger_description_cell">
              {{ row.description }}
            </td>
          }
          @case ('walletExpenseAmount') {
            <td
              data-pw="cw_ledger_expenses_cell"
              data-qa="cw_ledger_expenses_cell"
              [class.cw-amount-expense]="row.walletExpenseAmount < 0"
              [class.cw-amount-paid]="row.walletExpenseAmount > 0">
              @if (row.walletExpenseAmount !== null && row.walletExpenseAmount !== undefined) {
                {{ row.walletExpenseAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
              }
            </td>
          }
          @case ('orderId') {
            <td data-pw="cw_ledger_order_id_cell" data-qa="cw_ledger_order_id_cell">
              {{ row.orderId }}
            </td>
          }
          @case ('taxable') {
            <td data-pw="cw_ledger_taxable_cell" data-qa="cw_ledger_taxable_cell">
              {{ row.taxable }}
            </td>
          }
          @default {
            <td [attr.data-pw]="'cell-' + column.name" [attr.data-qa]="'cell-' + column.name">{{ row[column.name] }}</td>
          }
        }
      </ng-template>
            <!-- Expanded Row Template -->
      <ng-template #expandedRow let-detail>
        <div class="cw-expanded-row">
          <div class="cw-expanded-field">
            <span class="cw-expanded-label">Student PID</span>
            <span class="cw-expanded-value" data-pw="cw_ledger_expanded_student_pid" data-qa="cw_ledger_expanded_student_pid">{{ detail.studentPID || '—' }}</span>
          </div>
          <div class="cw-expanded-field">
            <span class="cw-expanded-label">Term</span>
            <span class="cw-expanded-value" data-pw="cw_ledger_expanded_term" data-qa="cw_ledger_expanded_term">{{ detail.term || '—' }}</span>
          </div>
          <div class="cw-expanded-field">
            <span class="cw-expanded-label">Order Id</span>
            <span class="cw-expanded-value" data-pw="cw_ledger_expanded_order_id" data-qa="cw_ledger_expanded_order_id">{{ detail.orderId || '—' }}</span>
          </div>
          <div class="cw-expanded-field">
            <span class="cw-expanded-label">Taxable</span>
            <span class="cw-expanded-value" data-pw="cw_ledger_expanded_taxable" data-qa="cw_ledger_expanded_taxable">{{ detail.taxable || '—' }}</span>
          </div>
        </div>
      </ng-template>
    </cfi-mat-table>
  }
</div>
